import { openingHoursSpecification } from './storeOpeningHours.js'
import { organizationId } from './seo.js'

export const STORE = {
  name: 'AGM Vision',
  telephone: '+33553551618',
  phoneNational: '05 53 55 16 18',
  phoneInternational: '+33 5 53 55 16 18',
  email: 'support@agmvision.com',
  streetAddress: '13 avenue Eugène Le Roy',
  postalCode: '24160',
  locality: 'Excideuil',
  region: 'Dordogne',
  country: 'FR',
  latitude: 45.336958,
  longitude: 1.0561354,
  mapUrl: 'https://maps.app.goo.gl/WCKAyxjj8NgnMhZ89',
  directionsUrl:
    'https://www.google.com/maps/dir/?api=1&destination=45.336958,1.0561354',
}

export const storeId = baseUrl => `${baseUrl}/magasin-excideuil#store`

export function storeNode({ baseUrl, url, image, openingHours, parkingName }) {
  return {
    '@type': 'AutoPartsStore',
    '@id': storeId(baseUrl),
    name: STORE.name,
    url,
    image,
    telephone: STORE.telephone,
    email: STORE.email,
    priceRange: '€€',
    currenciesAccepted: 'EUR',
    address: {
      '@type': 'PostalAddress',
      streetAddress: STORE.streetAddress,
      postalCode: STORE.postalCode,
      addressLocality: STORE.locality,
      addressRegion: STORE.region,
      addressCountry: STORE.country,
    },
    geo: {
      '@type': 'GeoCoordinates',
      latitude: STORE.latitude,
      longitude: STORE.longitude,
    },
    hasMap: STORE.mapUrl,
    parentOrganization: { '@id': organizationId(baseUrl) },
    knowsLanguage: ['fr', 'en'],
    amenityFeature: [
      {
        '@type': 'LocationFeatureSpecification',
        name: parkingName,
        value: true,
      },
    ],
    openingHoursSpecification: openingHoursSpecification(openingHours?.week),
    specialOpeningHoursSpecification: (openingHours?.closures || []).map(
      date => ({
        '@type': 'OpeningHoursSpecification',
        validFrom: date,
        validThrough: date,
        opens: '00:00',
        closes: '00:00',
      })
    ),
  }
}
